"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWrapCreatePanelItemWithDrag = exports.WrapCreatePanelItemWithDrag = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var useDashboardDrag_1 = require("./useDashboardDrag");
var draggableWidget_1 = require("./draggableWidget");
var model_1 = require("../../model");
/**
 * @internal
 */
exports.WrapCreatePanelItemWithDrag = function (props) {
    var _a = useWrapCreatePanelItemWithDrag(props), canDrag = _a.canDrag, dragItem = _a.dragItem, hideDefaultPreview = _a.hideDefaultPreview, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, children = _a.children;
    var _b = tslib_1.__read(useDashboardDrag_1.useDashboardDrag({
        dragItem: dragItem,
        canDrag: canDrag,
        hideDefaultPreview: hideDefaultPreview,
        dragEnd: function (_, monitor) {
            onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(monitor.didDrop());
        },
        dragStart: onDragStart,
    }, [canDrag, onDragEnd, hideDefaultPreview, dragItem]), 2), isDragging = _b[0].isDragging, dragRef = _b[1];
    return (react_1.default.createElement("div", { ref: dragRef, className: classnames_1.default({ "is-dragging": isDragging }) }, children));
};
/**
 * @internal
 */
function useWrapCreatePanelItemWithDrag(props) {
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var onDragEnd = draggableWidget_1.useWidgetDragEndHandler();
    var canDrag = isInEditMode && !props.disabled;
    return tslib_1.__assign(tslib_1.__assign({}, props), { canDrag: canDrag,
        onDragEnd: onDragEnd });
}
exports.useWrapCreatePanelItemWithDrag = useWrapCreatePanelItemWithDrag;
//# sourceMappingURL=WrapCreatePanelItemWithDrag.js.map